/** Regional Indian bridal head / face jewellery sub-options (ids match backend bridal_ornaments.py). */

export const BRIDAL_ORNAMENT_STYLES = [
  { id: 'none', label: 'Makeup only', region: 'No added jewellery' },
  {
    id: 'south_indian_temple',
    label: 'South Indian temple',
    region: 'Tamil Nadu · Karnataka',
  },
  { id: 'tamil_kalyanam', label: 'Tamil kalyanam', region: 'Sun–moon tikka · jadai' },
  { id: 'kerala_traditional', label: 'Kerala traditional', region: 'Mulla poo · kasu gold' },
  {
    id: 'north_indian_kundan',
    label: 'North Indian kundan',
    region: 'Maang tikka · passa · nath',
  },
  { id: 'punjabi_bridal', label: 'Punjabi bridal', region: 'Matha patti · jhumkas' },
  { id: 'rajasthani', label: 'Rajasthani', region: 'Borla · rakhdi' },
  { id: 'bengali', label: 'Bengali', region: 'Mukut · tikli · bindi' },
  { id: 'maharashtrian', label: 'Maharashtrian', region: 'Mundavalya pearls' },
  { id: 'gujarati', label: 'Gujarati', region: 'Rakhdi · kundan band' },
  { id: 'hyderabadi', label: 'Hyderabadi Deccan', region: 'Pearl passa · jugni' },
  { id: 'mughal_inspired', label: 'Mughal-inspired', region: 'Pearl drop tikka' },
];

export const BRIDAL_ORNAMENT_PRESET_IDS = new Set(['ceremony-indian', 'ceremony-bridal-soft']);

const DEFAULT_BY_PRESET = {
  'ceremony-indian': 'south_indian_temple',
  'ceremony-bridal-soft': 'north_indian_kundan',
};

/** Legacy ceremony presets — bridal UI is MakeupV3BridalLooksGrid; hide optional dropdown. */
export function presetSupportsBridalOrnaments(presetId) {
  return false;
}

export function defaultBridalOrnamentForPreset(presetId) {
  return DEFAULT_BY_PRESET[String(presetId || '').trim()] || 'none';
}

export function bridalOrnamentById(ornamentId) {
  return BRIDAL_ORNAMENT_STYLES.find((o) => o.id === ornamentId) || null;
}
